<template>
	
	<div :style="shu.yangshi" class="" style="display: flex;box-sizing:border-box;flex-wrap: wrap; padding: 10px;"  >
		<div v-for="l in shu.shu" class=""  :style="yangshis" style="width: 45%;margin-right: 10px;">
			<el-image :src="l.tu" class="" :style="yangshi" style="width: 100%;height: 50px;"></el-image>
			<!-- <div class="zidingyi_Fenlei_ming" :style="yangshi_zi">{{l.ming}}</div> -->
		</div>
	</div>
	
<!-- 
		<el-carousel height="136px" :autoplay="false">
			<el-carousel-item v-for="(page,index) of pages" :key="index">
				<div :style="shu.yangshi" class="zidingyi_Fenlei">
					<div v-for="(l,i) in page" :key="i" class="zidingyi_Fenlei_li" :style="yangshis">
						<el-image :src="l.tu" class="zidingyi_Fenlei_img" :style="yangshi"></el-image>
						<div class="zidingyi_Fenlei_ming" :style="yangshi_zi">{{l.ming}}</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel> -->
</template>

<script>
	export default { 
		name: 'shangpitu',
		data() {
			return {
				fenleilie: [{
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
						ming: '王 肖'
					},
					{
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
						ming: '王 肖'
					},
					{
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
						ming: '王 肖'
					},
					{
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
						ming: '王 肖'
					},
					{
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
						ming: '王 肖'
					}
				],
					yangshi: '',
					yangshis:'',
					yangshi_zi:''
			}
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		created() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', this.fenleilie)
			}
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}
			if (!this.shu.yangshis) {
				this.$set(this.shu, 'yangshis', {})
			}
			if (!this.shu.yangshi_zi) {
				this.$set(this.shu, 'yangshi_zi', {})
			}
		},
		watch: {
			// 分类盒子
			'shu.yangshis.width':function(){
				this.Yss();
			},
			'shu.yangshis.height':function(){
				this.Yss();
			},
			'shu.yangshis.text_align':function(){
				this.Yss();
			},
			'shu.yangshis.margin':function(){
				this.Yss();
			},
			'shu.yangshis.padding':function(){
				this.Yss();
			},
			'shu.yangshis.border_radius':function(){
				this.Yss();
			},
			// 图片
			'shu.yangshi.width':function(){
				this.Ys();
			},
			'shu.yangshi.height':function(){
				this.Ys();
			},
			'shu.yangshi.text_align':function(){
				this.Ys();
			},
			'shu.yangshi.margin':function(){
				this.Ys();
			},
			'shu.yangshi.padding':function(){
				this.Ys();
			},
			'shu.yangshi.border_radius':function(){
				this.Ys();
			},
			// 文字
			// 'shu.yangshi_zi.width':function(){
			// 	this.Ys();
			// },
			// 'shu.yangshi_zi.height':function(){
			// 	this.Ys();
			// },
			'shu.yangshi_zi.text_align':function(){
				this.Yszi();
			},
			'shu.yangshi_zi.margin':function(){
				this.Yszi();
			},
			'shu.yangshi_zi.padding':function(){
				this.Yszi();
			},
			'shu.yangshi_zi.font_size':function(){
				this.Yszi();
			},
			'shu.yangshi_zi.color':function(){
				this.Yszi();
			},
		},
		methods:{
			Ys(){
				this.yangshi = "";
				var px='';
				if (this.shu.yangshi.width) {
					px=(this.shu.yangshi.width>0)?(this.shu.yangshi.width+'px'):this.shu.yangshi.width;					
					this.yangshis += "width:" +px+ ";";
				}
				if (this.shu.yangshi.height) {				
					px=(this.shu.yangshi.height>0)?(this.shu.yangshi.height+'px'):this.shu.yangshi.height;		
					this.yangshi += "height:" + px+ ";";
				}
				if (this.shu.yangshi.text_align) {				
					this.yangshi += "text-align:" + this.shu.yangshi.text_align+ ";";
				}	
				if (this.shu.yangshi.margin) {
					px=(this.shu.yangshi.margin>0)?(this.shu.yangshi.margin+'px'):this.shu.yangshi.margin;		
					this.yangshi += "margin:" + px+ ";";
				}
				if (this.shu.yangshi.padding) {
					px=(this.shu.yangshi.padding>0)?(this.shu.yangshi.padding+'px'):this.shu.yangshi.padding;		
					this.yangshi += "padding:" + px+ ";";
				}
				if (this.shu.yangshi.border_radius) {
					px=(this.shu.yangshi.border_radius>0)?(this.shu.yangshi.border_radius+'px'):this.shu.yangshi.border_radius;		
					this.yangshi += "border-radius:" + px+ ";";
				}
				console.log(this.yangshi)
			},
			Yss(){
				this.yangshis = "";
				var px='';
				if (this.shu.yangshis.width) {
					px=(this.shu.yangshis.width>0)?(this.shu.yangshis.width+'px'):this.shu.yangshis.width;					
					this.yangshis += "width:" +px+ ";";
				}
				if (this.shu.yangshis.height) {				
					px=(this.shu.yangshis.height>0)?(this.shu.yangshis.height+'px'):this.shu.yangshis.height;		
					this.yangshis += "height:" + px+ ";";
				}
				if (this.shu.yangshis.text_align) {				
					this.yangshis += "text-align:" + this.shu.yangshis.text_align+ ";";
				}	
				if (this.shu.yangshis.margin) {
					px=(this.shu.yangshis.margin>0)?(this.shu.yangshis.margin+'px'):this.shu.yangshis.margin;		
					this.yangshis += "margin:" + px+ ";";
				}
				if (this.shu.yangshis.padding) {
					px=(this.shu.yangshis.padding>0)?(this.shu.yangshis.padding+'px'):this.shu.yangshis.padding;		
					this.yangshis += "padding:" + px+ ";";
				}
				if (this.shu.yangshis.border_radius) {
					px=(this.shu.yangshis.border_radius>0)?(this.shu.yangshis.border_radius+'px'):this.shu.yangshis.border_radius;		
					this.yangshis += "border-radius:" + px+ ";";
				}
				console.log(this.yangshis)
			},
			Yszi(){
				this.yangshi_zi = "";
				var px='';
				if (this.shu.yangshi_zi.text_align) {				
					this.yangshi_zi += "text-align:" + this.shu.yangshi_zi.text_align+ ";";
				}	
				if (this.shu.yangshi_zi.margin) {
					px=(this.shu.yangshi_zi.margin>0)?(this.shu.yangshi_zi.margin+'px'):this.shu.yangshi_zi.margin;		
					this.yangshi_zi += "margin:" + px+ ";";
				}
				if (this.shu.yangshi_zi.padding) {
					px=(this.shu.yangshi_zi.padding>0)?(this.shu.yangshi_zi.padding+'px'):this.shu.yangshi_zi.padding;		
					this.yangshi_zi += "padding:" + px+ ";";
				}
				if (this.shu.yangshi_zi.font_size) {
					px=(this.shu.yangshi_zi.font_size>0)?(this.shu.yangshi_zi.font_size+'px'):this.shu.yangshi_zi.font_size;		
					this.yangshi_zi += "font-size:" + px+ ";";
				}
				if (this.shu.yangshi_zi.color) {
					this.yangshi_zi += "color:" + this.shu.yangshi_zi.color+ ";";
				}
				l
				console.log(this.yangshi_zi)
			}
		},
		computed: {
		  pages(){
			  // var that=this
		    const pages = []; // pages是为二维数组
		    this.shu.shu.forEach((l, index) => {
		      const page = Math.floor(index / 10);
		      if (!pages[page]) {
		        pages[page] = [];
		      }
		      pages[page].push(l);
		    });
		    return pages;
		  }
		}
	}
</script>
